import { render, staticRenderFns } from "./PurchaseInvoiceItemReview.vue?vue&type=template&id=ee44a120&scoped=true&lang=pug&"
import script from "./PurchaseInvoiceItemReview.vue?vue&type=script&setup=true&lang=js&"
export * from "./PurchaseInvoiceItemReview.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PurchaseInvoiceItemReview.vue?vue&type=style&index=0&id=ee44a120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee44a120",
  null
  
)

export default component.exports